var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.$lang('language'),"item-text":"text","item-value":"value","prepend-icon":"mdi-translate","items":_vm.selectLanguages},on:{"change":function($event){return _vm.setTestLanguage()}},model:{value:(_vm.selectedTestLanguage),callback:function ($$v) {_vm.selectedTestLanguage=$$v},expression:"selectedTestLanguage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }